import { connect } from 'react-redux';
import {
  setConfig,
  setErrorMessage,
  setSuccessMessage,
  fetchUserData,
} from '../actions/contact-actions';
import Contact from '../components/contact';

const mapStateToProps = state => ({
  user: state.contact.authorizedUser,
  contactUrl: `${state.contact.config.SOAR_API_HOST}/user/0/contact`,
  isLoading: state.contact.isLoading,
  errorMessage: state.contact.errorMessage,
  successMessage: state.contact.successMessage,
});

const mapDispatchToProps = {
  setConfig: config => setConfig(config),
  setErrorMessage: errorMessage => setErrorMessage(errorMessage),
  setSuccessMessage: successMessage => setSuccessMessage(successMessage),
  fetchUserData: userId => fetchUserData(userId),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);
